"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.some"));

var _lodash2 = _interopRequireDefault(require("lodash.memoize"));

var _Applied = _interopRequireDefault(require("./Applied"));

var _Requested = _interopRequireDefault(require("./Requested"));

var _RequestAddons = _interopRequireDefault(require("./RequestAddons"));

var _InternalMode = _interopRequireDefault(require("./InternalMode"));

require("../styles/_addons-tab.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ButtonComponent = (0, _commonReact.requiresPermission)({
  ComponentToRender: _uiKit.Button,
  requiredPermission: 'UPDATE'
});
var RequestAddonsComponent = (0, _commonReact.requiresPermission)({
  ComponentToRender: _RequestAddons.default,
  requiredPermission: 'UPDATE'
});

var AddonsTab = /*#__PURE__*/function (_Component) {
  _inherits(AddonsTab, _Component);

  var _super = _createSuper(AddonsTab);

  function AddonsTab() {
    var _this;

    _classCallCheck(this, AddonsTab);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleClick", (0, _lodash2.default)(function (_ref) {
      var visible = _ref.visible;
      return function () {
        _this.setState({
          requestAddonsFormVisible: visible
        });
      };
    }));

    _this.state = {
      requestAddonsFormVisible: false
    };
    return _this;
  }

  _createClass(AddonsTab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getCurrentVersion = _this$props.getCurrentVersion,
          onUpdateRequestedAddons = _this$props.onUpdateRequestedAddons,
          videoPermissions = _this$props.videoPermissions,
          isVideoReady = _this$props.isVideoReady,
          getCurrentOutput = _this$props.getCurrentOutput,
          isInternalMode = _this$props.isInternalMode,
          updateAddonStatus = _this$props.updateAddonStatus;
      var requestAddonsFormVisible = this.state.requestAddonsFormVisible;
      var currentVersion = getCurrentVersion();

      var _getCurrentOutput = getCurrentOutput(),
          status = _getCurrentOutput.status,
          statusName = _getCurrentOutput.status.name;

      var isAddonsDisabled = !isVideoReady || ['INTERNAL_REVIEW', 'EDITING'].includes(statusName) || !(0, _commonReact.hasPermission)('UPDATE', videoPermissions) || statusName === 'COST_REVIEW' && !(0, _commonReact.hasPermission)('COST_APPROVAL', videoPermissions) || status.isCustom && !(0, _commonReact.hasPermission)(status.requiredPermission, videoPermissions);
      var hasAddons = (0, _lodash.default)(currentVersion.requestedAddons);
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "addons-tab"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "addons-tab__header"
        }, /*#__PURE__*/_react.default.createElement("h3", null, "Add-ons & Extras")), requestAddonsFormVisible ? /*#__PURE__*/_react.default.createElement(RequestAddonsComponent, {
          currentVersion: currentVersion,
          onUpdateRequestedAddons: onUpdateRequestedAddons,
          onCancel: this.handleClick({
            visible: false
          }),
          permissions: videoPermissions
        }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          className: "addons-tab__addons-wrapper"
        }, isInternalMode ? /*#__PURE__*/_react.default.createElement(_InternalMode.default, {
          currentVersion: currentVersion,
          updateAddonStatus: updateAddonStatus
        }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Applied.default, {
          currentVersion: currentVersion
        }), /*#__PURE__*/_react.default.createElement(_Requested.default, {
          currentVersion: currentVersion
        }))), hasAddons ? /*#__PURE__*/_react.default.createElement(ButtonComponent, {
          onClick: this.handleClick({
            visible: true
          }),
          className: "addons-tab__request-addons-button",
          type: "PRIMARY",
          permissions: videoPermissions,
          disabled: isAddonsDisabled
        }, "REQUEST CHANGES") : /*#__PURE__*/_react.default.createElement(ButtonComponent, {
          onClick: this.handleClick({
            visible: true
          }),
          className: "addons-tab__request-addons-button",
          type: "PRIMARY",
          permissions: videoPermissions,
          disabled: isAddonsDisabled
        }, "REQUEST ADDONS")))
      );
    }
  }]);

  return AddonsTab;
}(_react.Component);

var _default = AddonsTab;
exports.default = _default;